const QUESTION_TYPES = {
  FindHiddenWords: 1,
  FillMissingLetters: 2,
  QuestionsAndAnswers: 3,
  Matrix: 4
};

export { QUESTION_TYPES };
